import React, { FunctionComponent } from 'react';
import SyfLoader from 'syf-component-library/ui/atoms/Loader/SyfLoader';
import './loader.css';

const SynchronyLoader: FunctionComponent = () => {
  return (
    <div className="syf-loader-overly">
      <SyfLoader size={3} />
    </div>
  );
};

export default SynchronyLoader;
